import cs from './cs/printing.json';
import de from './de/printing.json';
import dev from './dev/printing.json';
import en from './en/printing.json';
import enAU from './en-AU/printing.json';
import enCA from './en-CA/printing.json';
import enUS from './en-US/printing.json';
import es from './es/printing.json';
import et from './et/printing.json';
import fi from './fi/printing.json';
import fr from './fr/printing.json';
import it from './it/printing.json';
import ru from './ru/printing.json';
import tr from './tr/printing.json';

export const receiptTranslations = {
  cs,
  de,
  dev,
  en,
  'en-AU': enAU,
  'en-CA': enCA,
  'en-US': enUS,
  es,
  et,
  fi,
  fr,
  it,
  ru,
  tr,
};
